// extracted by mini-css-extract-plugin
module.exports = {"doctorInfo":"DoctorInfoCard-module__doctorInfo___3AoTk","doctorInfoItem":"DoctorInfoCard-module__doctorInfoItem___1y77h"};